<main class="c-main" role="main">
  <div class="c-page-checkpolicy">
    <div class="container u-pb30">
      <div class="row mobile--orange u-pt40">
        <div class="col-md-8">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active " aria-current="page"><a
                [routerLink]="['/']">{{'PolicyManagementPortal.home' | translate}}</a></li>
              <li class="breadcrumb-item active" aria-current="page"> &nbsp; -
                <span> {{ 'PolicyManagementPortal.location' | translate}}</span></li>
            </ol>
          </nav>
          <h2 class="o-title ">{{ 'PolicyManagementPortal.title' | translate}}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8">
          <div class="u-pt20">
            <p class="o-text">{{ 'PolicyManagementPortal.paragraph1' | translate}}</p>
            <p class="o-text1">{{ 'PolicyManagementPortal.paragraph2' | translate}}</p>
            <div class="u-pt10 u-pb30">
              <a class="btn btn--primary" href="{{ urlPolicyPortal }}" target="_blank">
                <span class="">{{ 'PolicyManagementPortal.btnDownload' | translate}} </span>
              </a>
            </div>
            <p class="o-text">{{ 'PolicyManagementPortal.paragraph3' | translate}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>
